// ============================================================
// HOPE GIVER — SITE CONTENT
// Everything the pages render lives here so it is easy to update.
// Only real, confirmed Hope Giver activities appear on the site.
// ============================================================

export const ORG = {
  name: "Hope Giver",
  tagline: "Spreading Hope. Creating Change.",
  phoneDisplay: "9501385489",
  phoneTel: "tel:+919501385489",
  whatsappNumber: "919501385489",
  instagramHandle: "@Hope_giver2023",
  instagramUrl: "https://www.instagram.com/Hope_giver2023/",
};

// --- Real milestones (shown in About) -------------------------
export const MILESTONES = [
  {
    icon: "truck",
    title: "Punjab Floods Relief",
    status: "Done",
    desc: "Our team took trucks of food and essentials to flood-affected villages and handed them to families personally.",
    testid: "milestone-floods",
  },
  {
    icon: "home",
    title: "Unique Home Visit",
    status: "Done",
    desc: "We visited Unique Home to spend time with the community there and share our support.",
    testid: "milestone-unique-home",
  },
  {
    icon: "palette",
    title: "Soch Ke Rang 7.0",
    status: "Done",
    desc: "Our team took part in Soch Ke Rang 7.0, held at the Gymkhana.",
    testid: "milestone-soch-kerang",
  },
  {
    icon: "sparkle",
    title: "Our First Exhibition",
    status: "Coming soon",
    desc: "We are preparing our first exhibition right now — watch @Hope_giver2023 for the announcement.",
    testid: "milestone-exhibition",
  },
];

// --- About value cards ----------------------------------------
export const FEATURES = [
  {
    icon: "heart",
    title: "Compassion",
    desc: "Every act of service begins with a caring heart. We listen first, then act with kindness and dignity.",
  },
  {
    icon: "hands",
    title: "Community",
    desc: "We believe neighbours helping neighbours is the strongest force for good. Together is how we move forward.",
  },
  {
    icon: "leaf",
    title: "Positive Change",
    desc: "Small, consistent actions add up — creating ripples of change that last far beyond a single moment.",
  },
  {
    icon: "sparkle",
    title: "Hope",
    desc: "Hope is what we give, and hope is what we receive. It is the reason Hope Giver exists.",
  },
];

// --- Our Work (real activities only) ---------------------------
export const WORK = [
  {
    title: "Punjab Floods Relief",
    status: "Done",
    desc: "Truck loads of food and essentials, delivered hand to hand in flood-affected villages.",
    more: "When the floods hit Punjab, our team loaded trucks with food and essential supplies and reached families directly — village to village, hand to hand. The photos below are from that mission.",
    image: "/images/floods-truck.jpg",
    alt: "Hope Giver team distributing relief supplies from a truck during the Punjab floods",
    real: true,
  },
  {
    title: "Unique Home Visit",
    status: "Done",
    desc: "Our first visit to Unique Home — time, attention and essentials shared.",
    more: "We visited Unique Home once so far, spending time with the community there and sharing our support. It will not be our last visit.",
    icon: "home",
  },
  {
    title: "Soch Ke Rang 7.0",
    status: "Done",
    desc: "We took part in Soch Ke Rang 7.0 at the Gymkhana.",
    more: "Soch Ke Rang 7.0 was held at the Gymkhana, and the Hope Giver team was there — another step in our journey of bringing people together.",
    icon: "palette",
  },
  {
    title: "Our First Exhibition",
    status: "Coming soon",
    desc: "We are putting together our first exhibition right now.",
    more: "The exhibition is being planned — follow @Hope_giver2023 on Instagram to be the first to hear the date and details.",
    icon: "sparkles",
  },
];

// --- Impact timeline -------------------------------------------
export const TIMELINE = [
  { step: "Identify", desc: "We listen to communities and find where help is needed most." },
  { step: "Organize", desc: "Volunteers, supplies and partners come together into a plan." },
  { step: "Help", desc: "We deliver food, essentials and support — directly and respectfully." },
  { step: "Follow Up", desc: "We return, check in and make sure the help truly reached." },
  { step: "Create Lasting Change", desc: "Every drive ends with a plan to keep the impact alive." },
];

// --- Gallery (real Hope Giver photos only) ----------------------
export const GALLERY = [
  {
    src: "/images/floods-truck.jpg",
    title: "Punjab Floods Relief Convoy",
    caption: "Our team handing out food and essentials from the relief truck during the Punjab floods.",
    real: true,
  },
  {
    src: "/images/floods-handing.jpg",
    title: "Rations Into Safe Hands",
    caption: "Every kit passed on personally — food and essentials for a family in a flooded village.",
    real: true,
  },
  {
    src: "/images/floods-field.jpg",
    title: "Beside the Flooded Fields",
    caption: "Reaching families cut off by the rising water in Punjab.",
    real: true,
  },
];

// --- Marquee ----------------------------------------------------
export const MARQUEE_ITEMS = [
  "Spreading Hope",
  "Creating Change",
  "Serving Communities",
  "Rising Together",
];

// --- Instagram grid (real photos + links to the profile) --------
export const INSTAGRAM_GRID = [
  { src: "/images/floods-handing.jpg", alt: "Handing relief supplies during the Punjab floods" },
  { tile: true, text: "Soch Ke Rang 7.0 · Gymkhana" },
  { src: "/images/floods-truck.jpg", alt: "Relief truck at the Punjab floods" },
  { tile: true, text: "Unique Home visit" },
  { tile: true, text: "Exhibition — coming soon" },
  { tile: true, text: "@Hope_giver2023" },
];

// --- Hero / section images --------------------------------------
export const HERO_IMAGE =
  "https://images.pexels.com/photos/6646917/pexels-photo-6646917.jpeg?auto=compress&cs=tinysrgb&w=1920";

export const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1593113616828-6f22bca04804?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85";

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Our Work", href: "#work" },
  { label: "Get Involved", href: "#get-involved" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];
